import { ENDPOINT_MATCHING } from 'app/endpoints';

export const success = () => ({
    title: 'Schau in deinen Posteingang!',
    subtitle: 'Bitte klicke noch den Link in deiner <b>Bestätigungs-E-Mail</b>, '
        + 'um die Aktivierung deiner Job-Empfehlungen abzuschließen.',
});

export const alreadyExists = () => {
    const loginText = '<a class="m-resultState__loginLink">Melde dich an</a>, um sie anzusehen.';

    return {
        imagePath: '/assets/images/emptyState/matching-warning.jpg',
        retinaImagePath: '/assets/images/emptyState/matching-warning-2x.jpg',
        title: 'Deine Job-Empfehlungen warten schon auf dich!',
        subtitle: `Da du bereits einen karriere.at Lebenslauf hast,
        stehen deine Job-Empfehlungen schon für dich bereit: ${loginText}`,
        redirectLink: ENDPOINT_MATCHING,
    };
};

export const alreadySubscribed = () => ({
    imagePath: '/assets/images/emptyState/matching-warning.jpg',
    retinaImagePath: '/assets/images/emptyState/matching-warning-2x.jpg',
    title: 'Job-Empfehlungen bereits aktiv',
    subtitle: '<a class="m-resultState__loginLink">Melde dich an</a>, '
        + 'um deine Job-Empfehlungen anzusehen oder anzupassen.',
    redirectLink: ENDPOINT_MATCHING,
});

export const jobMatchingResultState = {
    success,
    alreadyExists,
    alreadySubscribed,
};
